import React from 'react'
import Text from '../../components/Text'
import { Testimonial, TestimonialContent } from '../../screens/Home/styles'
interface Props {
  title: string,
  subtitle: string,
  text: string,
  image: string,
}

const TestimonialCard: React.FC<Props> = ({ title = '', subtitle = '', text = '', image = '' }) => {
  return (
    <Testimonial
    >
      <img
        src={image}
        alt="Testimonial person" />

      <TestimonialContent>
        <Text
          style={{
            marginTop: '47px',
            marginBottom: '5px',
            color: 'rgba(0, 0, 0, 0.87)',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontWeight: '400',
            lineHeight: '23.44px',
            textAlign: 'left',
          }}
          tag="h1"
        >
          {title}
        </Text>
        <Text tag="h2"
          style={{
            marginTop: '0px',
            marginLeft: '0px',
            color: 'rgba(0, 0, 0, 0.54)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '18.75px',
            textAlign: 'left',
          }}
        >
          {subtitle}
        </Text>

        <Text tag="p"
          style={{
            color: '#29B6F6',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '18.75px',
            textAlign: 'left',
          }}
        >
          {text}
        </Text>
      </TestimonialContent>
    </Testimonial>
  )
}

export default TestimonialCard